export const getFileUrl = (file) => file?.id ? `https://drive.google.com/file/d/${file.id}/view?usp=sharing` : '';
